import { currencyOptions } from "@/common/const";
import {
  includedOptions,
  maintenanceSLAOptions,
} from "@/common/const/filter-options";
import maintenanceTypeOptions from "@/common/const/filter-options/maintainanceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const hardwareFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Vendor Product Name",
    name: "vendorProductName",
    required: true,
  },
  {
    inputType: "text",
    label: "OEM/Manufaturer Name",
    name: "manufaturerName",
    required: true,
  },
  {
    inputType: "text",
    label: "Product Code/Part Number",
    name: "productCode",
    required: true,
  },
  {
    inputType: "text",
    label: "Country",
    name: "country",
    required: true,
  },
  {
    inputType: "select",
    label: "Purchase Type",
    name: "purchaseType",
    required: true,
    options: [
      { label: "Resale", value: "Resale" },
      {
        label: "Rental",
        value: "Rental",
      },
    ],
  },
  {
    label: "Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "select",
    label: "Maintenance Type",
    name: "maintenanceType",
    required: true,
    options: maintenanceTypeOptions,
  },
  {
    inputType: "select",
    label: "Maintenance SLA",
    name: "maintenanceSla",
    required: true,
    options: maintenanceSLAOptions,
  },
  {
    inputType: "select",
    label: "Maintenance Status",
    name: "maintenanceStatus",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "License Name",
    name: "licenseName",
    required: true,
  },
  {
    inputType: "select",
    label: "License Status",
    name: "licenseStatus",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "select",
    label: "On-site Delivery Included",
    name: "onSiteDeliveryIncluded",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "On-site Installation Included",
    name: "onSiteInstallationIncluded",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "Custom/Duties Included",
    name: "dutiesIncluded",
    required: true,
    options: includedOptions,
  },
  {
    label: "Price code",
    name: "priceCode",
    required: false,
    inputType: "text",
  },
];
export default hardwareFormStrategy;
